import React from 'react'
import DeleteAccount from '../components/DeleteAccount/DeleteAccount'

const DeleteAccountPage = () => {
  return (
    <div className="w-full">
<DeleteAccount/>
    </div>
  )
}

export default DeleteAccountPage